import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Module } from 'src/services/api/models';
import { RootStateType } from 'src/services/redux/reducers';
import { RoutesEnum } from 'src/shared/enums/routes.enum';

/**
 * Typ för alla tillgängliga moduler
 */
export type ModuleNames = 'News' | 'Career' | 'Calendar' | 'Chat' | 'Form' | 'Employee' | 'Progress' | 'Order';

interface Props {
  moduleTitle: ModuleNames;
}

export const ModuleDisplayName: React.FC<Props> = ({ moduleTitle }) => {
  const { t, i18n } = useTranslation();
  const modules = useSelector((state: RootStateType) => state.appState.modules);
  const currentLanguage = i18n.language;
  // Hitta rätt modul
  const foundModule = modules.find((module: Module) => module.Title === moduleTitle);

  // Välj rätt språk beroende på currentLanguage
  const displayName = currentLanguage === 'en' ? foundModule?.DisplayNameEn?.trim() : foundModule?.DisplayNameSv?.trim();

  // Om båda DisplayNameSv & DisplayNameEn saknas, fallback till översättningsnyckeln
  return <>{displayName || t(`common:modules.${moduleTitle ? moduleTitle.toLowerCase() : ''}`)}</>;
};

export const getRouteForModule = (module: string) => {
  switch (module) {
    case 'News':
      return RoutesEnum.Start;
    case 'Calendar':
      return RoutesEnum.Calendar;
    //   case 'Chat':
    //     return RoutesEnum.;
    case 'Employee':
      return RoutesEnum.Employee;
    case 'Career':
      return RoutesEnum.Career;
    case 'Form':
      return RoutesEnum.Form;
    case 'Order':
      return RoutesEnum.LunchOrder;
    case 'Progress':
      return RoutesEnum.Progress;
    default:
      return RoutesEnum.Start; // Fallback-komponent
  }
};
